<!-- Angular Material Dialog Template -->
<h2 mat-dialog-title class="card-title">{{ data.title[this.language] }}</h2>
<mat-dialog-content>
  <img
    *ngIf="data.images?.length"
    src="{{ data.images[0] ||''}}"
    class="img-fluid mb-3"
    alt="Article Image"
  />
  <app-youtube-player
    *ngIf="data.videoUrl"
    [videoID]="data.videoUrl || ''"
    class="img-fluid mb-3"
  ></app-youtube-player>
  <!-- <video
        *ngIf="data.videoUrl"
        src="{{ data.videoUrl }}"
        img-fluid mb-3
        controls
      ></video> -->
  <p [innerHtml] = "data.description[this.language] | urlDetector"></p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>{{ "close" | translate }}</button>
</mat-dialog-actions>
<!-- </ng-template> -->
